import React, { useEffect, useState } from 'react';
import { dbDateToTimestamp, parseURL, parseEntities, toLongDateDisplay, parseDateDesktopShort } from '../../utils/helpers';

import FavouritesButton from './FavouritesButton';

import AgendaIcon from '../svg/AgendaIcon';

const Card = ({
	animationDelay,
	title,
	content,
	permalink,
	bundle_url,
	storyline,
	bundle_title,
	subtitle,
	lang,
	poster_desktop,
	poster_mobile,
	main_genre,
	tags,
	show_button,
	times,
	dates,
	date_range,
	setTagsParam,
	activeTab,
	post_id,
	toggleFavourite,
	allFavourites,
}) => {
	const [releaseDate, setReleaseDate] = useState('');

	useEffect(() => {
		if (date_range) {
			const date = dbDateToTimestamp(date_range[0] + '0000');
			setReleaseDate(date);
		}
	});

	useEffect(() => {
		if (dates?.release) {
			const date = dbDateToTimestamp(dates.release + '0000');
			setReleaseDate(date);
		}
	}, []);

	// useEffect(() => {
	// 	document.querySelectorAll('.js-favourite').forEach((el) => {
	// 		console.log(el)
	// 		new Favourites(el);
	// 	});
	// }, []);

	const mainGenreFormatted = main_genre && Object.values(main_genre)[0];
	let program_start, location, ticket_link, available, status_label;
	times?.length > 0 && ({ program_start, location, ticket_link, available, status_label } = times[0]);
	const year = program_start?.substring(0, 4);

	const formattedDate = releaseDate ? toLongDateDisplay(parseDateDesktopShort(releaseDate,lang), lang) : '';

	const activeClassName = `tile-${activeTab === 'series' ? 'series' : 'event'}`;
	let time = `${program_start?.substring(8, 10)}:${program_start?.substring(10, 12)}`;
	time = time === '04:00' ? '' : time; // Need a way to hide the time, see sc-41068 comment "timetable" for why this is 4:00
	return animationDelay ? (
		<li className={activeClassName} style={animationDelay}>
			{activeTab !== 'series' && (
				<div className="tile-event__location-date">
					{location && <p className="tile-event__location font-uppercase-small">{location}</p>}
					{releaseDate && (
						<time dateTime={formattedDate} className="tile__date heading-time">
							{formattedDate === 'vandaag' || formattedDate === 'morgen' ? formattedDate : `${formattedDate.slice(0, 3).join(' ')} ${formattedDate.slice(3, 5)}`}
							<span className="tile-event__year tile__year">
								{year} <span className="tile-event__dash">-</span>
							</span>
							{time}
						</time>
					)}
				</div>
			)}

			<div className={`${activeClassName}__img-container`}>
				{(poster_mobile || poster_desktop) && <img src={poster_mobile || poster_desktop} alt={title} className={`${activeClassName}__img`} />}
			</div>

			<div className={`${activeClassName}__information`}>
				<div className={`${activeClassName}__content`}>
					<a className={`${activeClassName}__link`} href={permalink || '#'}>
						<h3>{parseEntities(title)}</h3>
					</a>
					{content && <p>{content}</p>}
					{activeTab !== 'series' && bundle_title && (
						<h4 className="font-uppercase-small tile-event__subtitle">
							<a className="tile-event__bundle-link" href={bundle_url || '#'}>
								{parseEntities(bundle_title)}
							</a>
						</h4>
					)}
					{subtitle && <p className="tile-event__text">{parseEntities(subtitle)}</p>}
				</div>
				{activeTab !== 'series' && (
					<div className="tile-event__tags-button">
						<ul className="label-list">
							{mainGenreFormatted && mainGenreFormatted.trim() !== '' && mainGenreFormatted !== 'Leeg' && (
								<li className="agenda-item__tag" key="extra-item">
									<span className="label-item">{mainGenreFormatted}</span>
								</li>
							)}
							{tags &&
								Object.keys(tags).map((tag, index) => {
									return (
										<li className="agenda-item__tag" key={index} data-value={tags[tag]}>
											<span className="label-item">{parseEntities(tags[tag])}</span>
										</li>
									);
								})}
						</ul>

						<div className="full-width tile-event__buttons">

							{status_label && show_button != 'false' && (available && ticket_link ? (
								<a href={parseURL(ticket_link)} className="btn btn--tickets tile-event__tickets-link" aria-label={`tickets for ${parseEntities(title)} with status ${status_label}`}>
									<AgendaIcon />
									<span>{status_label}</span>
								</a>
							) : (
								<button className="btn btn--soldout tile-event__btn-sold-out" disabled aria-label>
									<span>{status_label}</span>
								</button>
							))}

							{toggleFavourite && <FavouritesButton itemId={post_id} toggleFavourite={toggleFavourite} allFavourites={allFavourites} />}

						</div>
					</div>
				)}
			</div>
		</li>
	) : (
		<li className={activeClassName}>
			{activeTab !== 'series' && (
				<div className="tile-event__location-date">
					{location && <p className="tile-event__location font-uppercase-small">{location}</p>}
					{releaseDate && (
						<time dateTime={formattedDate} className="tile__date heading-time">
							{formattedDate === 'vandaag' || formattedDate === 'morgen' ? formattedDate : `${formattedDate.slice(0, 3).join(' ')} ${formattedDate.slice(3, 5)}`}
							<span className="tile-event__year tile__year">
								{year} <span className="tile-event__dash">-</span>
							</span>
							{time}
						</time>
					)}
				</div>
			)}

			<div className={`${activeClassName}__img-container`}>
				{(poster_mobile || poster_desktop) &&
				<img
				loading="lazy"
				src={poster_mobile || poster_desktop}
				alt={title}
				className={`${activeClassName}__img`} />}
			</div>

			<div className={`${activeClassName}__information`}>
				<div className={`${activeClassName}__content`}>
					<a className={`${activeClassName}__link`} href={permalink || '#'}>
						<h3>{parseEntities(title)}</h3>
					</a>
					{content && <p>{content}</p>}
					{activeTab !== 'series' && bundle_title && (
						<h4 className="font-uppercase-small tile-event__subtitle">
							<a className="tile-event__bundle-link" href={bundle_url || '#'}>
								{parseEntities(bundle_title)}
							</a>
						</h4>
					)}
					{subtitle && <p className="tile-event__text">{parseEntities(subtitle)}</p>}
				</div>
				{activeTab !== 'series' && (
					<div className="tile-event__tags-button">
						<ul className="label-list">
							{mainGenreFormatted && mainGenreFormatted.trim() !== '' && mainGenreFormatted !== 'Leeg' && (
								<li className="agenda-item__tag" key="extra-item">
									<span className="label-item">{mainGenreFormatted}</span>
								</li>
							)}
							{tags &&
								Object.keys(tags).map((tag, index) => {
									return (
										<li className="agenda-item__tag" key={index} data-value={tags[tag]}>
											<span className="label-item">{parseEntities(tags[tag])}</span>
										</li>
									);
								})}
						</ul>

						<div className="full-width tile-event__buttons">
							{status_label && show_button != 'false' && (available && ticket_link ? (
								<a href={parseURL(ticket_link)} className="btn btn--tickets tile-event__tickets-link" aria-label={`tickets for ${parseEntities(title)} with status ${status_label}`}>
									<AgendaIcon />
									<span>{status_label}</span>
								</a>
							) : (
								<button className="btn btn--soldout tile-event__btn-sold-out" disabled aria-label>
									<span>{status_label}</span>
								</button>
							))}

							{toggleFavourite && <FavouritesButton itemId={post_id} toggleFavourite={toggleFavourite} allFavourites={allFavourites} />}

						</div>
					</div>
				)}
			</div>
		</li>
	);
};

export default Card;
